<div class="small-modal-wrapper">
  <ng-container *ngIf="!serverError">
    <span
      >Är du säker på att du vill matcha dessa betalningar med varandra?
      🙂</span
    >
    <app-form-error *ngIf="errorMessage" [errorText]="errorMessage">
    </app-form-error>

    <div class="button-container">
      <zaver-secondary-button-subtle
        style="width: auto"
        [text]="'Tillbaka'"
        [disabled]="requestInProgress"
        (click)="closeModal()"
        [size]="'x-small'"
      ></zaver-secondary-button-subtle>
      <zaver-primary-button
        style="width: auto"
        [text]="'Ja, matcha'"
        [loading]="requestInProgress"
        [color]="'black'"
        (click)="submit()"
        [size]="'x-small'"
      ></zaver-primary-button>
    </div>
  </ng-container>

  <ng-container *ngIf="serverError">
    <app-server-error [errorMessage]="serverErrorMessage"></app-server-error>

    <div class="button-container">
      <zaver-secondary-button-subtle
        style="width: auto"
        [text]="'Stäng'"
        [disabled]="requestInProgress"
        (click)="closeModal()"
        [size]="'x-small'"
      ></zaver-secondary-button-subtle>
      <zaver-primary-button
        style="width: auto"
        [text]="'Försök igen'"
        [loading]="requestInProgress"
        [color]="'black'"
        (click)="submit()"
        [size]="'x-small'"
      ></zaver-primary-button>
    </div>
  </ng-container>
</div>
